import React, { useState } from 'react';
import './Candidates.css';

const candidates = [
  { initials: 'LS', name: 'Lamia Sayed', role: 'Full-Stack Dev', score: 99.2, skills: ['Node.js', 'System Design'], rank: 1, appliedFor: 'Backend Systems', status: 'Reviewed', color: '#4A90D9' },
  { initials: 'AJ', name: 'Ahmed Jawad', role: 'Frontend Engineer', score: 98.8, skills: ['React', 'Python'], rank: 2, appliedFor: 'Senior Frontend Dev', status: 'New', color: '#6B52E0' },
  { initials: 'SK', name: 'Sara Kader', role: 'UX Designer', score: 97.2, skills: ['Python', 'AWS'], rank: 3, appliedFor: 'UX Design', status: 'Hired', color: '#4A90D9' },
  { initials: 'KM', name: 'Kofi Mensah', role: 'ML Engineer', score: 96.3, skills: ['Figma', 'Redis'], rank: 4, appliedFor: 'Full-Stack', status: 'Rejected', color: '#6B52E0' },
  { initials: 'FO', name: 'Fairouz Oweza', role: 'ML Engineer', score: 95.1, skills: ['AWS', 'Nuxt.js'], rank: 5, appliedFor: 'Full-Stack', status: 'Reviewed', color: '#6B52E0' },
  { initials: 'SA', name: 'Sofia Amrawi', role: 'Product Designer', score: 86.9, skills: ['D3.js', 'CI/CD'], rank: 6, appliedFor: 'Product Design', status: 'New', color: '#7B6EF6' },
  { initials: 'CV', name: 'Celia Vaya', role: 'Backend/Cloud Eng.', score: 81.4, skills: ['System Design', 'Docker'], rank: 7, appliedFor: 'Cloud Architecture', status: 'Rejected', color: '#6B52E0' },
  { initials: 'LF', name: 'Luca Ferrakh', role: 'Data Scientist', score: 80.4, skills: ['TailwindCSS', 'Go'], rank: 8, appliedFor: 'Data Analysis', status: 'New', color: '#7B6EF6' },
  { initials: 'NO', name: 'Nela Okfado', role: 'Product Designer', score: 79.1, skills: ['Docker', 'TailwindCSS'], rank: 9, appliedFor: 'Product Design', status: 'Shortlisted', color: '#7B6EF6' },
  { initials: 'AD', name: 'Amara Dima', role: 'UX Designer', score: 76.6, skills: ['Kubernetes', 'Figma'], rank: 10, appliedFor: 'UX Design', status: 'Reviewed', color: '#30B8C8' },
  { initials: 'ML', name: 'Mei Lin', role: 'DevOps Specialist', score: 72.8, skills: ['SQL', 'GraphQL'], rank: 11, appliedFor: 'ML Engineering', status: 'New', color: '#3ECF7A' },
  { initials: 'HK', name: 'Hana Kobayashi', role: 'Full-Stack Dev', score: 72.2, skills: ['Vue.js', 'Rust'], rank: 12, appliedFor: 'Backend Systems', status: 'Rejected', color: '#4A90D9' },
  { initials: 'JL', name: 'Jordan Lee', role: 'Data Scientist', score: 71.7, skills: ['TypeScript', 'SQL'], rank: 13, appliedFor: 'Data Analysis', status: 'Shortlisted', color: '#4A90D9' },
  { initials: 'DR', name: 'Diego Reyes', role: 'Systems Engineer', score: 71.6, skills: ['Rust', 'CI/CD'], rank: 14, appliedFor: 'Cloud Architecture', status: 'Shortlisted', color: '#6B52E0' },
  { initials: 'EP', name: 'Elena Petrov', role: 'DevOps Specialist', score: 71.4, skills: ['Go', 'Next.js'], rank: 15, appliedFor: 'ML Engineering', status: 'Hired', color: '#3ECF7A' },
  { initials: 'YA', name: 'Yusuf Al-Rashid', role: 'Frontend Engineer', score: 63.4, skills: ['GraphQL', 'Kubernetes'], rank: 16, appliedFor: 'Senior Frontend Dev', status: 'Hired', color: '#6B52E0' },
];

const statusColor = { Reviewed: 'blue', New: 'purple', Hired: 'green', Rejected: 'red', Shortlisted: 'yellow' };

export default function Candidates() {
  const [search, setSearch] = useState('');
  const filtered = candidates.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.role.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page candidates">
      <div className="page-header">
        <div>
          <h1 className="page-title">Candidates</h1>
          <p className="page-sub">All applicants who have completed skill assessments</p>
        </div>
      </div>

      <div className='haha'>
      <div className="candidates-filters">
        <div className="search-input">
          <span>🔍</span>
          <input
            placeholder="Name or skill..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        {['Frontend Dev', '90–100', 'All Status', 'Score ↓'].map(f => (
          <button key={f} className="filter-btn">{f}</button>
        ))}
      </div>

      <div className="card">
        <table className="data-table">
          <thead>
            <tr>
              <th>CANDIDATE</th>
              <th>SCORE</th>
              <th>SKILLS</th>
              <th>RANK</th>
              <th>APPLIED FOR</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={i}>
                <td>
                  <div className="cand-row">
                    <div className="cand-avatar-sm" style={{ background: c.color }}>{c.initials}</div>
                    <div>
                      <div style={{ fontWeight: 500, color: 'var(--text-primary)', fontSize: 12.5 }}>{c.name}</div>
                      <div style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>{c.role}</div>
                    </div>
                  </div>
                </td>
                <td style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{c.score}</td>
                <td>
                  <div className="skill-tags">
                    {c.skills.map(s => <span key={s} className="skill-tag">{s}</span>)}
                  </div>
                </td>
                <td style={{ color: 'var(--text-muted)' }}>#{c.rank}</td>
                <td>{c.appliedFor}</td>
                <td><span className={`status-badge ${statusColor[c.status]}`}>{c.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
}